module.exports = __webpack_public_path__ + "media/outlook-wizard/Card-0587a2d6.svg";